'use client';

import { observer } from 'mobx-react-lite';
import { SearchEventResult } from 'searchEvent.d';
import { ParamsResult } from 'ParamsResult';
import { useMemo } from 'react';
import SearchEventList from 'components/SearchEventList/SearchEventList';
import { Pagination } from '@sympla/sympla-components';
import { PaginationExtraLabel } from 'components/Shared';
import { componentTrackingSearch } from 'constants/search';

import { ContainerComponent } from 'components/new-components/Container/Container.css';
import { Title } from './ListEventsCollection.css';

function ListEventsCollection({
  dataSectionMoreEvents,
  serviceParams,
  isMobile,
  fecthEvents,
  isLoading,
  label,
}: {
  dataSectionMoreEvents: SearchEventResult;
  serviceParams?: ParamsResult;
  isMobile: boolean;
  isLoading: boolean;
  fecthEvents: (query: string) => void;
  label: string;
}) {
  const extraLabel = useMemo(
    () => (isMobile ? <PaginationExtraLabel currentResults={dataSectionMoreEvents.data?.length} total={dataSectionMoreEvents.total} /> : <div />),
    [dataSectionMoreEvents.data, dataSectionMoreEvents.total],
  );

  const totalPages = useMemo(() => {
    if (!dataSectionMoreEvents?.limit) return 1;
    return Math.ceil(dataSectionMoreEvents.total / dataSectionMoreEvents.limit);
  }, [dataSectionMoreEvents.limit, dataSectionMoreEvents.total]);

  return (
    <div className={ContainerComponent}>
      <h2 className={Title}>{`Explore mais eventos de ${label}`}</h2>
      <SearchEventList
        events={dataSectionMoreEvents.data}
        labelTracking={componentTrackingSearch.sectionMoreEventsCollection}
        serviceParams={serviceParams}
        isMobile={isMobile}
      />
      <Pagination
        isLoading={isLoading}
        lang="pt"
        totalPages={totalPages || 1}
        currentPage={Number(dataSectionMoreEvents.page) || 1}
        onChangePage={(page: string | number) => {
          fecthEvents(`${window.location.search}&page=${page}`);
          return +page;
        }}
        extraLabel={extraLabel}
        isMobile={isMobile}
      />
    </div>
  );
}

export default observer(ListEventsCollection);
